import { useState, useEffect } from "react";

/**
 * Hook that waits for fonts to be loaded before allowing render.
 * Prevents FOUT (Flash of Unstyled Text) in development.
 */
export function useFontLoader(): boolean {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    // Check if fonts are already loaded
    if (document.fonts.status === "loaded") {
      setFontsLoaded(true);
      return;
    }

    // Wait for fonts to load
    document.fonts.ready.then(() => {
      setFontsLoaded(true);
    });
  }, []);

  return fontsLoaded;
}
